import { render, staticRenderFns } from "./PriceWorkflowTimeline.vue?vue&type=template&id=2dcb35c7&scoped=true&"
import script from "./PriceWorkflowTimeline.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowTimeline.vue?vue&type=style&index=0&id=2dcb35c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb35c7",
  null
  
)

export default component.exports